function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M276.3,365.7c41.3-68.5,93.5-164.8,93.5-214.3C369.8,67.9,301.9,0,218.4,0S67,67.9,67,151.4 c0,49.5,52.2,145.8,93.5,214.3c-49,3.7-160.5,17-160.5,61.1C0,470.2,113.2,490,218.5,490c105.2,0,218.5-19.8,218.5-63.2 C436.9,382.7,325.3,369.4,276.3,365.7L276.3,365.7z M87.9,151.4c0-72,58.6-130.6,130.5-130.6c72,0,130.6,58.6,130.6,130.6 c0,62.9-100.2,220.7-130.6,267.1C188,372.1,87.9,214.3,87.9,151.4L87.9,151.4z M218.4,469.1c-127.9,0-197.6-28-197.6-42.4 c0-11.1,46-35,152-41.1c19.9,32.1,35,54.8,37,57.5c2.7,3.6,10.6,7.9,17.3,0c2.1-2.5,17.1-25.4,37-57.5c106,6.1,152,29.9,152,41.1 C416,441.2,346.3,469.1,218.4,469.1L218.4,469.1z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M284.3,151.4c0-36.4-29.5-65.9-65.9-65.9s-65.9,29.5-65.9,65.9s29.5,65.9,65.9,65.9 S284.3,187.8,284.3,151.4z M173.3,151.4c0-24.9,20.2-45.1,45.1-45.1s45.1,20.2,45.1,45.1s-20.2,45.1-45.1,45.1 S173.3,176.3,173.3,151.4z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 45,
    viewBox: "0 0 437 490"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/icon-location.84ef5060.svg";
export { SvgComponent as ReactComponent };